<template>
  <div class="add-to-home" :class="{ ios: isSafari }">
    <div v-if="isSafari" class="add-to-home-container-ios">
      <div class="add-to-home-header">
        <p class="title">Install the app</p>
        <div class="close-btn" @click="showHomeScreen(false)">
          <i class="fa fa-times"></i>
        </div>
      </div>

      <div class="user-card">
        <img class="icon" :src="salesIcon" :alt="salesName + 'icon'" />
        <h3>{{ salesName }}</h3>
        <a :href="salesWebsite">{{ salesWebsite }}</a>
      </div>

      <ol class="instruction">
        <li>
          Tap on the
          <svg class="icon" viewBox="0 0 32 33" fill="none">
            <rect width="32" height="33" rx="4" fill="#F2F2F2" />
            <rect
              x="7"
              y="11.4492"
              width="18"
              height="17"
              rx="3"
              stroke="#0C86FF"
              stroke-width="2"
            />
            <rect x="13" y="10" width="6" height="3" fill="#F2F2F2" />
            <path
              d="M16.5303 2.46967C16.2374 2.17678 15.7626 2.17678 15.4697 2.46967L10.6967 7.24264C10.4038 7.53553 10.4038 8.01041 10.6967 8.3033C10.9896 8.59619 11.4645 8.59619 11.7574 8.3033L16 4.06066L20.2426 8.3033C20.5355 8.59619 21.0104 8.59619 21.3033 8.3033C21.5962 8.01041 21.5962 7.53553 21.3033 7.24264L16.5303 2.46967ZM16.75 19L16.75 3H15.25L15.25 19H16.75Z"
              fill="#0C86FF"
            />
          </svg>
          in the browser toolbar
        </li>
        <li>
          Scroll down and select
          <span class="add-home">Add to Home Screen</span>
        </li>
        <li>
          Look for the
          <img class="icon" :src="salesIcon" :alt="salesName + 'icon'" /> icon
          on your home screen
        </li>
      </ol>
    </div>

    <div v-else class="add-to-home-container flex">
      <div v-if="isChrome && !isSamsungBrowser" class="speech-bubble-container">
        <div class="speech-bubble">
          <div style="font-weight:700">SAVE MY CARD</div>
          <div style="font-size:15px">
            Tap<img src="/static/images/show-more-button-with-three-dots.svg" />
            choose <strong>Add to Homescreen</strong> and then
            <strong>Save</strong>
          </div>
        </div>
      </div>

      <div v-if="isSamsungBrowser" class="speech-bubble-container">
        <div class="speech-bubble-without-triangle">
          <div style="font-weight:700">SAVE MY CARD</div>
          <div style="font-size:15px">
            Tap <img src="/static/images/add-homescreen-samsung.svg" />
            <strong>Homescreen</strong> and <strong>Add</strong>
          </div>
        </div>
      </div>

      <div>
        <div class="flex flex-center">
          <div
            class="main-title"
            :style="{ 'border-bottom-color': customization.mainColor }"
          >
            DIGITAL CARD BENEFITS
          </div>
        </div>
        <div class="features" v-if="getBenefits.length > 0">
          <div class="flex feature" v-for="item in getBenefits" :key="item.id">
            <div
              class="feature-icon"
              :style="{ background: customization.mainColor }"
            >
              <div
                class="icon-add-to-home flex flex-center"
                :class="item.icon"
                :style="{ color: customization.iconColor }"
              ></div>
            </div>
            <div class="feature-description flex">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>

      <div class="select-right" style="padding-bottom:10px;">
        <input
          type="button"
          @click="showHomeScreen(false)"
          style="font-size:13.3px; font-weight:bold;width: 50%;margin: 0 auto;"
          value="Close"
          class="button form_submit"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";

export default {
  name: "add-to-homescreen-adaptive",
  computed: {
    ...mapState({
      isSafari: (state) => state.standalone.isSafari,
      isChrome: (state) => state.standalone.isChrome,
      isSamsungBrowser: (state) => state.standalone.isSamsungBrowser,
      customization: (state) => state.common.customization,
      industryId: (state) => state.common.industryId,
      salesWebsite: (state) => state.common.salesSite,
      salesName: (state) => state.common.salesPersonFullName,
      salesIcon: (state) => state.common.salesPersonIcon,
    }),
    getBenefits() {
      if (this.industryId === 1) {
        return benefitList;
      } else {
        return benefitListNotAutomotive;
      }
    },
  },
  mounted: function() {},
  methods: {
    ...mapActions({
      showHomeScreen: "standalone/showAddHomeScreen",
    }),
  },
  data() {
    return {
      // benefits: benefitList,
      // benefitsNonAutomotive: benefitListNotAutomotive
    };
  },
};

var benefitList = [
  {
    id: 1,
    text: "Easy way to ask me a question!",
    icon: "icon-home-conversation",
  },
  {
    id: 2,
    text: "Shop Full Vehicle Inventory",
    icon: "icon-home-car",
  },
  {
    id: 3,
    text: "Download virtually any manufacturing brochure",
    icon: "icon-home-brochure",
  },
  {
    id: 4,
    text: "Download virtually any owner's manual",
    icon: "icon-home-manual",
  },
  {
    id: 5,
    text: "Recommend A Friend™ and earn!",
    icon: "icon-home-wage",
  },
  {
    id: 6,
    text: "And much, much more!",
    icon: "icon-home-star",
  },
];

var benefitListNotAutomotive = [
  {
    id: 1,
    text: "Immediate answers to the questions you want",
    icon: "icon-home-conversation",
  },
  {
    id: 2,
    text: "Easy way to communicate with me through chat, SMS, email, and phone",
    icon: "icon-home-smartphone",
  },
  {
    id: 3,
    text: "Professional education advice when you need",
    icon: "icon-home-reading",
  },
  {
    id: 4,
    text: "Learn more about me and our products",
    icon: "icon-home-idea",
  },
  {
    id: 5,
    text: "And much, much more!",
    icon: "icon-home-star",
  },
];
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  max-width: 100%;
}

.add-to-home {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100000;
  top: 0;
  background: rgba(0, 0, 0, 0.7);
}

.add-to-home.ios {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  background: rgba(0, 0, 0, 0.1);
}

.add-to-home-container {
  position: relative;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: flex-start;
}

.add-to-home-container img {
  height: 20px;
}

.add-to-home-container-ios {
  --radius: 0.8em;
  width: 100%;
  background-color: #fff;
  padding: 24px;
  box-sizing: border-box;
  border-top-left-radius: var(--radius);
  border-top-right-radius: var(--radius);
}

.add-to-home-container-ios .close-btn {
  width: 18px;
  height: 18px;
  display: grid;
  place-content: center;
  flex: 0 0 18px;
}

.add-to-home-container-ios .close-btn > i {
  font-size: 1.2rem;
  line-height: 2rem;
}

.add-to-home-container-ios .add-to-home-header {
  display: flex;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 24px;
}

.add-to-home-container-ios .add-to-home-header .title {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 800;
}

.add-to-home-container > div {
  margin: 10px 0px;
}

.flex {
  display: flex;
}

.flex-center {
  justify-content: center;
}

.main-title {
  color: white;
  font-size: 25px;
  border-bottom: 1px solid yellow;
  font-weight: 600;
}

.icon-add-to-home {
  color: black;
  width: 50px;
  height: 50px;
  align-items: center;
}

.feature-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 20px;
  background: yellow;
}

.feature-description {
  color: white;
  font-size: 14px;
  align-items: center;
}

.features {
  margin-top: 15px;
  padding: 0px 20px;
}

.feature {
  margin: 10px 0px;
}

.speech-bubble,
.speech-bubble-bottom,
.speech-bubble-without-triangle {
  position: relative;
  background: white;
  border-radius: 5px;
  padding: 5px;
  text-align: center;
}

.speech-bubble:after {
  content: "";
  position: absolute;
  top: 0;
  left: calc(100% - 25px);
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-bottom-color: white;
  border-top: 0;
  margin-top: -10px;
}

.speech-bubble-bottom:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: calc(50% - 12px);
  width: 0;
  height: 0;
  border: 10px solid transparent;
  border-top-color: white;
  border-bottom: 0;
  margin-bottom: -10px;
}

.speech-bubble-container {
  width: 90%;
  padding: 0px 5%;
}

.speech-bubble-container-bottom {
  width: 90%;
  padding: 0px 5%;
}
.add-home-img {
  height: auto;
  width: 100%;
}

.user-card {
  display: grid;
  grid-template-columns: 64px 1fr;
  column-gap: 24px;
  align-content: flex-start;
  border: 1px solid #e6e7e9;
  background-color: #f3f4f6;
  padding: 18px;
  border-radius: 5px;
}

.icon {
  display: block;
  aspect-ratio: 1;
}

img.icon {
  border-radius: 8px;
}

.user-card > * {
  line-height: 1;
}

.user-card img {
  grid-area: span 2;
}

.user-card h3 {
  padding: 0;
  font-weight: 700;
}

.user-card a {
  font-weight: 600;
  word-break: break-all;
}

.instruction {
  font-weight: 600;
}

.instruction .icon {
  display: inline-block;
  width: 1.5em;
}

.instruction .add-home {
  padding: 2px 4px;
  background-color: #f5f5f5;
  font-weight: 700;
  display: inline-block;
}

ol.instruction {
  list-style: numeric;
  padding-left: 1rem;
  display: grid;
  row-gap: 1em;
  margin-top: 1em;
  margin-bottom: 0.5em;
}

ol.instruction > li {
  margin-left: 0.5rem;
}

ol.instruction > li .icon {
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// add-to-homescreen-adaptive.vue?5b234c86